/**
 * Get an SVG icon from the sprite (matches PHP renderIcon output)
 * @param {string} name - The icon name (without 'icon-' prefix)
 * @param {Object} [options] - Optional settings
 * @param {number} [options.rotation] - Rotation in degrees (e.g., 90, -90, 180)
 * @param {string} [options.className] - Additional CSS classes for the wrapper
 * @returns {string} Icon markup with wrapper span
 */
export function getIcon(name, options = {}) {
    const { rotation, className } = options;
    const classes = ['sitchco-icon', `sitchco-icon--${name}`, className].filter(Boolean).join(' ');
    const style = rotation ? ` style="--sitchco-icon-transform: rotate(${rotation}deg)"` : '';
    const svg = `<svg aria-hidden="true"><use fill="currentColor" href="#icon-${name}"></use></svg>`;
    return `<span class="${classes}"${style}>${svg}</span>`;
}
